import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    ADDITIONAL_INFO_TITLE: 'redeem-additional-info__title',
    ADDITIONAL_INFO_MESSAGE: 'redeem-additional-info__message'
};

export const INITIAL_ANALYTICS_DATA = {
    flowStep: 'additional information',
    category: CATEGORY.DISPLAY,
    action: 'additional information'
};

export const ON_NEXT_CLICK_ANALYTICS_DATA = {
    ...INITIAL_ANALYTICS_DATA,
    flowStep: 'additional information',
    category: CATEGORY.ACTION,
    action: 'next'
};
